import { atom } from 'recoil';

export const showChatBoxAtom = atom({
    key: 'showChatBoxAtom',
    default: false,
});